<template>
  <div class="animated fadeIn">
    <b-container fluid class="pt-3 pr-3 pb-0 pl-3">
      <b-row>
        <b-col cols="12" class="">
          <!-- Cancellations -->
          <b-card class="border-0">
            <div class="card-text pb-0">
              <div class="d-flex flex-row justify-content-start">
                <div class="text-dark mr-3"><i class="el-icon-document"></i></div>
                <div class="h4 font-weight-bold text-dark">Tilmeld Betalingsaftale</div>
              </div>
              <div class="pt-3 h6 open-sans line-height-golden">
                Integrationer med leverandørservice.
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <b-form>
    <b-container fluid class="pt-0 pr-3 pb-0 pl-3">
      <b-row>
        <b-col>
          <!-- notifications in general -->
          <b-card class="border-0 p-1">

            <div class="d-flex flex-row align-items-center justify-content-between">
              <div class="h6 text-dark"> <b-img src="../static/img/leverandoerservice.png" alt=""  /></div>
              <div>
                <b-btn size="lg" variant="dark" v-if="help !== ''" class="rounded">
                  <span class="mr2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"/></svg></span>
                  Hjælp
                </b-btn>
              </div>
            </div>

            <div class="card-text pb-0">
              <div>
                <b-collapse  visible  id="details1" class="">
                  <div class="py-2 open-sans h6 line-height-golden">




                    LeverandørService er en betalingsløsning til erhvervskunder, hvor fakturaer betales automatisk på betalingsdagen. Du modtager altid en advisering mindst 3 dage inden beløbet trækkes og din faktura vil du kunne hente via dit personlige login til vores platform.

                  </div>
                  <div class="d-flex flex-row justify-content-start">
                    <b-col lg="6" md="6" sm="12">

                      <b-alert show variant="success" v-if="levandorupdate !== ''">
                        <h5 class="alert-heading">Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.
                        </h5>
                        <p>
                        </p>

                      </b-alert>
                      <b-form class="py-2" @submit.stop.prevent="service_levendor">
                        <b-form-group id="nameInput" label="Din Bank" label-for="konto">
                          <b-form-select v-model="bank" :options="options" required></b-form-select>
                          <b-form-text id="password-help-block">
                            Hvis din bank ikke er på listen, kan du ikke oprette forbindelse til leverandørservice
                          </b-form-text>
                        </b-form-group>
                        <b-form-group id="nameInput" label="Registreringsnr." label-for="konto">
                          <b-form-input id="konto" type="number" v-model="regnr" aria-describedby="input-live-help input-live-feedback" :formatter="limitbankregis" :state="regState" required placeholder="" max="9999" size="4" class="bg-light rounded" autocomplete="off"></b-form-input>
                          <b-form-text id="password-help-block">
                            Indsæt venligst din Registreringsnr (4 kar)
                          </b-form-text>
                        </b-form-group>
                        <b-form-group id="emailInput" label="Bankkonto" label-for="account">
                          <b-form-input id="account" type="number" v-model="bankkonto" required placeholder="" :formatter="limitbankno" :state="bankState" class="bg-light rounded" size="10" max="9999999999" autocomplete="off"></b-form-input>
                          <b-form-text id="password-help-block">
                            Indsæt venligst din Bankkonto (10 kar)
                          </b-form-text>
                        </b-form-group>

                          <b-form-group id="emailInput" label="CVR-nummer" label-for="cvr">
                              <b-form-input id="cvr" type="number" v-model="cvr" required placeholder="" class="bg-light rounded" autocomplete="off" ></b-form-input>
                          </b-form-group>

                        <div class="py-2"></div>


                        <b-form-row>
                          <b-col>
                            <b-form-group label-for="consentInput" class="">
                              <b-form-checkbox id="consentInput" v-model="consent" value="accepted" required unchecked-value="not_accepted">
                                <span class="text-secondary open-sans">Jeg acceptere LeverandørService <a target="_blank" href="https://www.nets.eu/dk-da/SiteCollectionDocuments/leverandoerservice/LS_Regler_DB_debitor_regler_DK.pdf">reglerne</a></span>
                              </b-form-checkbox>
                            </b-form-group>
                          </b-col>
                        </b-form-row>
                        <div class="py-2"></div>
                        <b-row>
                          <b-col v-if="levandorupdate === ''"><b-button type="submit" variant="success rounded flex justify-center items-center" size="lg">
                            <span class="mr2"><svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-chevrons-circle-right-f"><path d='M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z' /></svg></span>Gem
                          </b-button></b-col>
                          <b-col v-if="levandorupdate !== ''"> <b-alert size="lg" show variant="secondary"><span  class="el-icon-success text-success"></span> Sidste opdatering : {{ levandorupdate }} </b-alert></b-col>
                        </b-row>
                        <div class="py-2"></div>
                      </b-form>
                    </b-col>
                  </div>
                  <div class="py-2"></div>
                  <div class="py-2"></div>
                  <div class="py-2"></div>
                  <div class="py-2"></div>
                  <div class="py-2"></div>
                  <div class="py-2"></div>
                </b-collapse>
              </div>
            </div>
            <div slot="footer" class="border-0"></div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
      <b-modal  size="lg" ref="dinerowModal" centered id="modalPopover"  title="Hent vejledning her" ok-only>
        <b-col md="12" class="h-100 d-inline-block">
        <b-embed type="iframe" scrolling="no"  src="" aspect="1by1"  allowfullscreen ></b-embed>
        </b-col>
        <div slot="modal-footer" class="py-4 px-4 d-flex justify-content-between w-100">
          <b-btn type="reset" variant="outline-dark" size="lg"  @click="hideModal" class="float-left">Luk
          </b-btn>
        </div>
      </b-modal>
    </b-form>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <updatebitrixpackagepermission   ref="updatebitrixpackagepermission"></updatebitrixpackagepermission>
  </div>
</template>
<script>
import hotlinemodal from './modals/HotlineModal'
import archivemodal from './modals/ArchiveModal'
import Haandvaerker from './haandvaerker'
import updatebitrixpackagepermission from '../../components/updatebitrixpackagepermission'
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import Imentor from './imentor'
export default {
  name: 'profilesettings',
  data () {
    return {
      regnr: '',
      bankkonto: '',
      help: '',
      cvr: '',
      consent: '',
      dineroShow: false,
      items: [],
      bank: '',
      options: [],
      optionsDistance: [],
      firmaid: '',
      partnertype: 'SMS-partner',
      levandorupdate: '',
      show: false,
      imentor: true,
      label: 'Loading...',
      overlay: 1,
      haaId: '',
      salesPerson: ''
    }
  },
  computed: {
    regState () {
      return this.regnr.length > 3
    },
    bankState () {
      return this.bankkonto.length > 9
    }
  },
  components: {
    Imentor,
    Haandvaerker,
    hotlinemodal,
    archivemodal,
    loading,
    Simplert,
    updatebitrixpackagepermission
  },
  created () {
    this.Reload()
    if (localStorage.getItem('imentor') === '0') {
      this.imentor = false
    }
  },
  methods: {
    limitbankno (e) {
      return String(e).substring(0, 10)
    },
    limitbankregis (e) {
      return String(e).substring(0, 4)
    },
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var dataPartner = {operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1'}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.cvr = res.cvr
            if (this.haaId === '40035' || this.haaId === '10247') {
              this.levandorupdate = ''
            } else {
              this.levandorupdate = res.levandorupdate
            }
            this.regnr = res.levandorregnr
            this.bankkonto = res.levandorbankkonto
            this.options = res.bankOptions
          },
          response => {
            alert('error')
          }
        )
    },
    service_levendor () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      var dataPartner = {operation: 'service_levendor', salesPerson: this.salesPerson, regnr: this.regnr, bankkonto: this.bankkonto, levid: this.haaId, cvr: this.cvr, bank: this.bank}
      this.$http.post('', dataPartner, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
              }
              this.$refs.simplert.openSimplert(obj)
              this.Reload()
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    hideModal () {
      this.$refs.dinerowModal.hide()
    },
    showModal () {
      this.$refs.dinerowModal.show()
    }
  }
}
</script>
<style scoped>
.modal-header,
.modal-footer {
  border-top: 0;
  border-bottom: 0;
}
.card-footer {
  border-top: 0;
  border-bottom: 0;
  background-color: #fff;
}
.switch-success > .switch-input:not(checked) ~ .switch-label {
  background: #CF000F;
  color: #fff;
  border: 0;
}
.switch-success > .switch-input:not(checked) ~ .switch-label::before {
  color: #fff!important;
}
.fa-exclamation-triangle {
  font-size: 26px;
}
</style>



// WEBPACK FOOTER //
// leverandoerservice.vue?6765fe27